import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import axios from '../../../../axios';

import MuiSwitch from '../../../MuiFields/Switch';

import useTableStore from '../../../../store/table';

// useContext hook to access the table store
import { useTableId } from '../../../../contexts/TableId'; 

import MuiAutocompleteMulti from '../../../MuiFields/MuiAutocompleteMulti';

import { useQuery } from '@tanstack/react-query';

const SwitchContainer = styled.div`
  margin-bottom: 1.4rem;
  border: 1px solid ${props => props.theme.colors.border};
  background-color: white;
  padding: 1.5rem;
  border-radius: 3px;
`;


const prefetchOptions = async (url) => {
  try {
    const { data } = await axios.get(url);
    return data?.rows;
  } catch (e) {
    return null;
  }
}

const AutoMulti = ({ field, subfield = "$in", label, url, values, fieldOptions, prefetch, additionalCollections }) => {
  const tableId = useTableId(); // Get the table ID from context

  const resetFilters = useTableStore(state => state.resetTableFilters);
  const handleFilter = useTableStore(state => state.handleTableFilter);
  let fieldValue = useTableStore(state => state.tableFilters[tableId]?.[field]) || {};

  const [ serverOptions, setServerOptions ] = useState(values || []);

  let { fieldName, displayField } = fieldOptions || {};

  const onChange = (ids) => {
    if (ids?.length) {
      handleFilter(ids, tableId, field, subfield, "array");
    } else {
      resetFilters(tableId, field, subfield, false);
    }
  }

  console.log(values, "values", fieldOptions, "fieldOptions", fieldValue, "fieldValue");

  console.log(url, prefetch, "url, prefetch");
  const { data: options } = useQuery({
    queryKey: [url],
    queryFn: () => prefetchOptions(url),
    enabled: !!prefetch && !!url,
    staleTime:  30 * 60 * 1000
  })

  useEffect(() => {
    if (options) {
      setServerOptions(options);
    }
  }, [options])

  let multiUrl = url?.startsWith('/') ? url?.substring(1) : url;

  return (
    <SwitchContainer>
      <MuiAutocompleteMulti
        multiple={true}
        fieldName={fieldName}        // The unique key in your data
        displayField={displayField || fieldName}   // The property to show in the UI
        value={fieldValue?.$in}   // Array of strings/IDs
        onChange={onChange}
        url={multiUrl}     // Endpoint for debounced search
        serverOptions={serverOptions}
        additionalCollections={additionalCollections}
      />
    </SwitchContainer>
  );
};

export default AutoMulti;